import { payments } from "@wayke-se/ecom";
import { validatePayment } from "../tools/data-validation";
export const getPaymentLookup = (data, callback) => {
    const isValidRequestData = validatePayment(data.ecomData, data.orderOptions, data.paymentLookup);
    if (!isValidRequestData) {
        return callback(null);
    }
    const builder = payments
        .newLookupRequest()
        .forVehicle(data.vehicleId)
        .withDownPayment(data.ecomData.loanDeposit)
        .withDuration(data.ecomData.loanDuration);
    const hasResidual = data.ecomData.loanResidual !== null;
    if (hasResidual) {
        builder.withResidualValue(data.ecomData.loanResidual);
    }
    if (data.dealerId) {
        builder.forDealer(data.dealerId);
    }
    const request = builder.build();
    payments
        .lookupPayment(request)
        .then((response) => {
        callback(response);
    })
        .catch(() => {
        callback(null);
    });
};
